import React from "react"
import Nav from "react-bootstrap/Nav"
import "../../styles/_press.scss"
import { Row, Container, Col } from "react-bootstrap"

const PressRoomMasthead = props => {
  const { active } = props
  return (
    <div className="press-masthead">
      <Container fluid>
        <Row className="justify-content-center py-4">
          <Col md="8">
            <h1 className="display-4 text-center">SpaceIt Press Room</h1>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Nav
            activeKey={active}
            defaultActiveKey="press-releases"
            variant="underline"
          >
            <Nav.Link href="/p/press-releases" eventKey="press-releases">
              Press Releases
            </Nav.Link>

            <Nav.Link href="/p/news" eventKey="news">
              In the News
            </Nav.Link>
          </Nav>
        </Row>
      </Container>
    </div>
  )
}

export default PressRoomMasthead
